<template>
	<div class="pingzheng">
        <main>
            <span>车牌： </span>
            <el-input v-model="chepai" placeholder="车牌" style="display:inline-block" clearable></el-input>

            <span>起止日期： </span>
            <el-date-picker
                v-model="time"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                format="yyyy 年 MM 月 dd 日"
                value-format="yyyy-MM-dd">
            </el-date-picker>

            <span style="margin-left: 20px;">状态： </span>
            <el-select v-model="zhuangtai" placeholder="请选择">
                <el-option label="待审核" value="0"></el-option>
                <el-option label="通过" value="1"></el-option>
                <el-option label="拒绝" value="2"></el-option>
            </el-select>

            <el-button style="margin-left:20px" type="success" icon="el-icon-search" @click="search()">搜索</el-button>
            <el-button type="info" icon="el-icon-download" @click="daochu()">导出</el-button>

        </main>
        
        <el-card style="border: solid #ccc 1px">
            <el-table
                :data="tableData"
                stripe
                border
                height="60vh"
                style="width: 200%">

                <el-table-column
                    prop="create_time"
                    label="提交时间">
                </el-table-column>

                <el-table-column
                    prop="chepai"
                    label="车牌">
                </el-table-column>

                <el-table-column
                    prop="name"
                    label="驾驶员">
                </el-table-column>

                <el-table-column
                    prop="address"
                    label="出发地点">
                </el-table-column>

                <el-table-column
                    prop="address3"
                    label="出发地点">
                </el-table-column>

                <el-table-column
                    prop="time"
                    label="出发日期">
                </el-table-column>

                <el-table-column
                    prop="address2"
                    label="到达地点">
                </el-table-column>

                <el-table-column
                    prop="address4"
                    label="到达地点">
                </el-table-column>

                <el-table-column
                    prop="time2"
                    label="到达日期">
                </el-table-column>

                <el-table-column
                    prop="toushu"
                    label="头数">
                </el-table-column>

                <el-table-column
                    prop="siwangtoushu"
                    label="死亡头数">
                </el-table-column>

                <el-table-column
                    prop="licheng1"
                    label="出发里程">
                </el-table-column>

                <el-table-column
                    prop="licheng2"
                    label="结束">
                </el-table-column>

                <el-table-column
                    prop="beizhu"
                    label="备注">
                </el-table-column>

                <el-table-column
                    width="350"
                    label="照片">
                    <template slot-scope="scope">
                        <span v-for="(item,i) in (scope.row.url).split(',')">
                            <el-popover
                                placement="bottom"
                                trigger="click">
                                <img :src="item" alt="" style="width:500px;height:500px">
                                <img :src="item" alt="" style="width:100px;height:100px;margin-right:20px" slot="reference" >
                            </el-popover>
                        </span>
                    </template>
                </el-table-column>

                <el-table-column label="状态">
                    <template slot-scope="scope">
                        <p v-if="scope.row.status==0">待审核</p>
                        <p style="color:#67C23A" v-if="scope.row.status==1">审核通过</p>
                        <p style="color:#F56C6C" v-if="scope.row.status==2">审核拒绝</p>
                    </template>
                </el-table-column>

                <el-table-column label="审核" width="160">
                    <template slot-scope="scope" >
                        <div v-if="scope.row.status!=1">
                            <el-button type="text" @click="caoZuo(scope.row,1)">通过</el-button>
                            <el-button type="text" style="color:#F56C6C" @click="caoZuo(scope.row,2)">拒绝</el-button>
                            <el-button type="text" style="color:#909399" @click="caoZuo(scope.row,3)">删除</el-button>
                        </div>
                    </template>
                </el-table-column>

                <el-table-column
                    prop="shenpiren"
                    label="审核人">
                </el-table-column>

            </el-table>

            <el-pagination
                style="margin:20px 0"
                background
                @current-change="handleCurrentChange"
                :current-page="current_page"
                :page-size="per_page"
                layout="prev, pager, next"
                :total="total">
            </el-pagination>

        </el-card>        

    </div>
</template>

<script>
    import { url } from '../router/api';
	export default{
		data(){
			return{
                total: 1,
                per_page: 50,
                current_page: 1,
                tableData: [],

                zhuangtai:'',
                chepai:'',
                time:[],
                
            }
        },
        async mounted() {
            var date = new Date();
            date.setTime(date.getTime());
            var Y = date.getFullYear() + '-';
            var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
            var D = (date.getDate() < 10 ? '0'+(date.getDate()) : date.getDate());
            var time1 = Y + M + '01'
            var time2 = Y + M +D
            this.time.push(time1)
            this.time.push(time2)

            await this.getList()
        },
		methods: {
            search() {
                this.current_page = 1
                this.getList()
            },

            handleCurrentChange(val) {
                this.current_page = val;
                this.getList();
            },
            
            async getList() {
                const loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: '加载中',
                    background: 'rgba(0, 0, 0, 0.7)'
                });

                var time1 = ''
                var time2 = ''
                if(this.time) {
                    time1 = this.time[0] + ' 00:00:00'
                    time2 = this.time[1] + ' 23:59:59'
                }
               
                await this.axios.get(url+'xs/xsList', {
                    params:{
                        page:this.current_page,
                        per_page:this.per_page,
                        chepai:this.chepai,
                        zhuangtai:this.zhuangtai,
                        time1:time1,
                        time2:time2,
                    }
                }).then(res=> {
                    this.tableData = res.data.data.data
                    this.total = res.data.data.total
                    loading.close();
                }).catch(err=> {
                    console.log(err);
                    loading.close();
                });
            },
            
            daochu() {
                const loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: '加载中',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                var time1 = ''
                var time2 = ''
                if(this.time) {
                    time1 = this.time[0] + ' 00:00:00'
                    time2 = this.time[1] + ' 23:59:59'
                }
                this.axios.get(url +'xs/xsList', {
                    params:{
                        export:1,
                        page:this.current_page,
                        per_page:this.per_page,
                        chepai:this.chepai,
                        zhuangtai:this.zhuangtai,
                        time1:time1,
                        time2:time2,
                    },
                    responseType: 'blob',
                    
                }).then(res=> {
                    const data = res.data 
                    if (Object.prototype.toString.call(data) === '[object Blob]' && data.type.includes('application/vnd.ms-excel')) { 
                        const blob = res.data
                        const a = document.createElement('a')
                        let binaryData = [];
                        binaryData.push(blob);
                        const url= window.URL.createObjectURL(new Blob(binaryData));
                        a.href = url
                        a.download = '下载.csv'
                        a.click()
                        window.URL.revokeObjectURL(url)
                    }else{
                        this.$message.error('下载失败')
                    }
                    loading.close();
                }).catch(err=> {
                    loading.close();
                    console.log(err);
                });
            },

            caoZuo(x,y) {
                this.$confirm('是否确定?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.axios.get(url+'xs/caoZuo', {
                        params:{
                            id:x.id,
                            id_status:y,
                            shenpiren:localStorage.getItem('ws_name'),
                        }
                    }).then(res=> {
                        if(res.data.code==1) {
                            this.$message({
                                message: '操作成功',
                                type: 'success'
                            });
                            this.getList()
                        } else {
                            this.$message({
                                message: res.data.msg,
                                type:'error'
                            });
                        }
                    }).catch(err=> {
                        console.log(err);
                    });
                }).catch(() => {});
            }
        }

    }
</script>

<style scoped="scoped" lang='less'>
    .pingzheng {
        padding-left: 10px;
        span {
            font-size: 12px;
        }
    }
    .pingzheng .el-input {
        width:140px;
        margin-right: 20px;
    }
 
    .pingzheng .el-select {
        width:140px;
        margin-right: 20px;
    }
    .pingzheng main {
        margin-bottom: 20px;
    }
    .pingzheng .el-pagination {
        white-space: nowrap;
        padding: 2px 5px;
        color: #303133;
        float: right;
        font-weight: 700;
    }
</style>

